import { ITheme, IStyle, mergeStyleSets } from "@fluentui/react";
import { BwjPalette } from "../../app-core/app-theme";

export const INTERNAL__getAppHeaderStyles = (theme: ITheme) => {

  const header: IStyle = {
    backgroundColor: theme.palette.white,
    zIndex: 2,
    margin: 0,
    padding: 0,
    width: '100%',
    fontSize: '0.7rem',

    '& a': {
      textDecoration: 'none',
    },
    '& h1': {
      margin: 0,
      padding: '1em 0',
      fontSize: '1em',
    }
  };

  const headerMain: IStyle = {
    margin: '0 auto',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-end',
    padding: '0 2rem',
    borderBottom: `1px solid ${theme.palette.neutralQuaternary}`,
  };

  const leftContainer: IStyle = {
    display: 'flex',
    flexDirection: 'row',
    gap: '1em',
    alignItems: 'center',
  };

  const headerMenu: IStyle = {
    margin: 0,
    padding: 0,
    display: 'flex',
    gap: '0.25em',
  };

  const menuButton: IStyle = {
    all: 'unset',
    display: 'none',
    width: '5em',
    height: '5em',
    justifyContent: 'center',
    alignItems: 'center',
    fontWeight: 700,
    margin: 0,
    color: theme.palette.themePrimary,

    '&:hover': {
      color: BwjPalette.themeGrey,
    },

    '& > i': {
      fontSize: '3em',
    },
  };

  const desktopMenuButton: IStyle = {
    ...menuButton,

    '@media(min-width: 651px)': {
      display: 'flex',
    },
  };

  const mobileMenuButton: IStyle = {
    ...menuButton,

    '@media(max-width: 650px)': {
      display: 'flex',
    },
  };

  const subtitle: IStyle = {
    display: 'none',
    margin: 0,
    padding: 0,
    fontSize: '1.6em',
    fontWeight: 600,

    '& i': {
      display: 'inline-block',
      paddingLeft: '0.5em',
    },
  };

  const subtitleDesktop: IStyle = {
    ...subtitle,
    color: BwjPalette.themeGrey,

    '@media(min-width: 650px)': {
      display: 'block',
    },
  };

  const subtitleMobile: IStyle = {
    ...subtitle,
    padding: '0.5rem 0',
    textAlign: 'center',
    backgroundColor: BwjPalette.accentPrimary,
    color: theme.palette.white,
    fontWeight: 500,

    '@media(max-width: 649px)': {
      display: 'block',
    },
  };

  return mergeStyleSets({
    header,
    headerMain,
    leftContainer,
    headerMenu,
    desktopMenuButton,
    mobileMenuButton,
    subtitleDesktop,
    subtitleMobile,
  });
}